import { FormPageType, FORM_PAGE_TYPE } from 'shared';
import { CurrentPageState, CURRENT_PAGE_STATE_TYPE } from 'store';

export const convertPageTypeIntoCurrentPageStateType = (
  pageType: FormPageType
): Extract<
  CurrentPageState['type'],
  | 'authentication'
  | 'input'
  | 'confirm'
  | 'complete'
  | 'private'
  | 'receptionAuthenticationError'
> => {
  switch (pageType) {
    case FORM_PAGE_TYPE.INPUT:
      return CURRENT_PAGE_STATE_TYPE.input;
    case FORM_PAGE_TYPE.CONFIRM:
      return CURRENT_PAGE_STATE_TYPE.confirm;
    case FORM_PAGE_TYPE.COMPLETE:
    case FORM_PAGE_TYPE.RECEPTION_COMPLETE:
      return CURRENT_PAGE_STATE_TYPE.complete;
    case FORM_PAGE_TYPE.RECEPTION_AUTHENTICATION_ERROR:
      return CURRENT_PAGE_STATE_TYPE.receptionAuthenticationError;
    case FORM_PAGE_TYPE.PRIVATE:
      return CURRENT_PAGE_STATE_TYPE.private;
    case FORM_PAGE_TYPE.AUTHENTICATION:
      return CURRENT_PAGE_STATE_TYPE.authentication;
  }
};

export * from './submission';
